/** Get Summary Dashboard data */
export const SNAP_SHOT_API_SUCCESS = "SNAP_SHOT_API_SUCCESS";
export const SNAP_SHOT_API_FAIL = "SNAP_SHOT_API_FAIL";
export const GET_SNAP_SHOT_DATA = "GET_SNAP_SHOT_DATA";
